const specialCharacters = [
  " ",
  "!",
  '"',
  "#",
  "\\$",
  "%",
  "&",
  "'",
  "\\(",
  "\\)",
  "\\*",
  "\\+",
  ",",
  "-",
  "\\.",
  "/",
  ":",
  ";",
  "<",
  "=",
  ">",
  "\\?",
  "@",
  "\\[",
  "\\\\",
  "\\]",
  "\\^",
  "_",
  "`",
  "{",
  "\\|",
  "}",
  "~"
].join("|");
const noTripleCharacters = /^(?:(.)\1?(?!\1))+$/;
const minLength = (password, amount) => password.length >= amount;
const MODERATE_LENGTH = 6;
const STRONG_LENGTH = 8;
const EXCELLENT_LENGTH = 10;
const containsRequiredCharacters = (password) => password.length >= STRONG_LENGTH;
const lowercaseRule = /[a-z]/;
const containsLowercase = (value) => lowercaseRule.test(value);
const uppercaseRule = /[A-Z]/;
const containsUppercase = (value) => uppercaseRule.test(value);
const numberRule = /[0-9]/;
const containsNumber = (value) => numberRule.test(value);
const specialCharacterRule = new RegExp(specialCharacters);
const containsSpecialCharacter = (value) => specialCharacterRule.test(value);
const minRequiredCharacterTypes = 3;
const characterTypeRules = [lowercaseRule, uppercaseRule, numberRule, specialCharacterRule];
function isModerate(password) {
  const requiredRules = [lowercaseRule, uppercaseRule, numberRule];
  const rulesPassed = requiredRules.filter((rule) => rule.test(password));
  return minLength(password, MODERATE_LENGTH) && rulesPassed.length === requiredRules.length;
}
function isStrong(password) {
  const rulesPassed = characterTypeRules.filter((rule) => rule.test(password));
  return minLength(password, STRONG_LENGTH) && rulesPassed.length >= minRequiredCharacterTypes;
}
function isExcellent(password) {
  const rulesPassed = characterTypeRules.filter((rule) => rule.test(password));
  const passedNoTripleCharacters = noTripleCharacters.test(password);
  return minLength(password, EXCELLENT_LENGTH) && passedNoTripleCharacters && rulesPassed.length >= minRequiredCharacterTypes;
}
function isWeak(password) {
  return !isModerate(password) && !isStrong(password) && !isExcellent(password);
}
function getPasswordStrength(password) {
  const measurements = [
    ["weak", isWeak(password)],
    ["moderate", isModerate(password)],
    ["strong", isStrong(password)],
    ["excellent", isExcellent(password)]
  ];
  return measurements.reduce(
    (strength, [key, value]) => value ? key : strength,
    "weak"
  );
}
function isPasswordBelowStrengthLevel(password, strength) {
  const currentStrength = getPasswordStrength(password);
  switch (strength) {
    case "excellent":
      return currentStrength !== "excellent";
    case "strong":
      return currentStrength === "weak" || currentStrength === "moderate";
    case "moderate":
      return currentStrength === "weak";
  }
}
export {
  EXCELLENT_LENGTH,
  MODERATE_LENGTH,
  STRONG_LENGTH,
  containsLowercase,
  containsNumber,
  containsRequiredCharacters,
  containsSpecialCharacter,
  containsUppercase,
  getPasswordStrength,
  isExcellent,
  isModerate,
  isPasswordBelowStrengthLevel,
  isStrong,
  lowercaseRule,
  minLength,
  noTripleCharacters,
  numberRule,
  specialCharacterRule,
  uppercaseRule
};
//# sourceMappingURL=utils.js.map
